import React, { FC } from 'react';
import { Button } from '@domain-group/fe-co-button';
import * as PortalApi from '../../lib/portal-api';
import { useStatus } from '../status-store';

interface DemoConfigurationProps {
  callbackUrl: string;
  credentialId: string;
  callbackFunction: (
    credential: PortalApi.CredentialViewModel,
    allowAuthentication: boolean,
  ) => void;
}

const DemoConfiguration: FC<DemoConfigurationProps> = ({
  credentialId,
  callbackUrl,
  callbackFunction,
}) => {
  const status = useStatus();
  const configure = async () => {
    // alert(`Configure ${credentialId} with ${callbackUrl}`)
    const credential = await PortalApi.getCredential(
      status.accessToken,
      credentialId,
    );
    if (!credential) {
      throw Error(`Could not retrieve credential with id ${credentialId}`);
    }
    credential?.redirectUris.push(callbackUrl);
    const updatedCredential = await PortalApi.updateCredential(
      status.accessToken,
      credential,
    );
    if (updatedCredential) {
      // Minor hack here, we override the usual "canAuthenticate" logic. See notes in the callback
      callbackFunction(updatedCredential, true);
    } else {
      // eslint-disable-next-line no-alert
      alert('Error during configuration');
    }
  };

  // allow reset the authorisation of swagger token
  return (
    <>
      <p>
        This project is not configured for use with the Live API Documentation.
      </p>
      <p>Configuration will add the required redirect URL to the Client</p>
      <ul>
        <li>{callbackUrl}</li>
      </ul>
      <p>
        <Button
          appearance="ghostPrimary"
          size="small"
          onClick={async () => {
            await configure();
          }}
        >
          Configure
        </Button>
      </p>
    </>
  );
};

export default DemoConfiguration;
